import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { devicesSelector } from "../../selectors/devices";
import { gpsSelector } from "../../selectors/gps";
import { getTypingDevicesRequest, setStateDevices, getDevicesStatusesRequest } from "../../actions/devices";
import AutoCompleteUsers from "./AutoCompleteDevices";

const mapStateToProps = createStructuredSelector({
    devices: devicesSelector,
    gps: gpsSelector
});
const mapDispatchToProps = {
    getTypingDevicesRequest,
    setStateDevices,
    getDevicesStatusesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteUsers);
